import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

// Función para incrementar el contador y obtener el nuevo valor
export const incrementarContador = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${API_URL}/api/Contadores/incrementar`, // Ajustamos la ruta
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data.valor; // Devuelve el nuevo valor del contador
};
